import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CourseCard } from "../../components/card";
import { Btn } from "../../components/button/Btn";
import { CiSearch } from "react-icons/ci";
import Search from "../../components/Search";

const Lesson = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const courses = [
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",
      image: "/assets/course.png",
      to: "/lessons/subject-details",
    },
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",
      image: "/assets/course_2.png",
      to: "/lessons/subject-details",
    },
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",
      image: "/assets/course_3.png",
      to: "/lessons/subject-details",
    },
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",
      image: "/assets/course_4.png",
      to: "/lessons/subject-details",
    },
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",
      image: "/assets/course.png",
      to: "/lessons/subject-details",
    },
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",
      image: "/assets/course_2.png",
      to: "/lessons/subject-details",
    },
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",

      image: "/assets/course_3.png",
      to: "/lessons/subject-details",
    },
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",
      image: "/assets/course_4.png",
      to: "/lessons/subject-details",
    },
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",
      image: "/assets/course.png",
      to: "/lessons/subject-details",
    },
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",
      image: "/assets/course_2.png",
      to: "/lessons/subject-details",
    },
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",

      image: "/assets/course_3.png",
      to: "/lessons/subject-details",
    },
    {
      title: "Course Title",
      description:
        "Lorem ipsum dolor sit amet consectetur. Quis morbi fermentum molestie mauris risus sit mi nullam.",
      duration: "2.5 hours",
      topics: "3 ",
      image: "/assets/course_4.png",
      to: "/lessons/subject-details",
    },
  ];

  return (
    <>
      <div className="p-6 bg-white rounded-lg shadow-md m-4">
        <div className="">
          <div className="flex justify-between items-center px-4">
            <div className="flex items-center gap-8">
              <h1 className="text-[20px] font-bold text-[#400167]">
                My Courses
              </h1>
              {/* Search Field */}
              <Search onSearch={handleSearch} />
            </div>
            <Link to="/lessons/new-subjects">
              <Btn>Add Course</Btn>
            </Link>
          </div>
          <header className="flex justify-between items-center py-4"></header>
          <div className="grid grid-cols-4 gap-2 px-4">
            {courses.map((course, index) => (
              <CourseCard key={index} {...course} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Lesson;
